// components/CheckoutPage.jsx
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import config from '../config/config';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

// Components (same as ProductView)
import ShareableNav from "../components/ShareableNav";
import FlashBar from "../components/FlashBar";
import NavigationBar from "../components/NavigationBar";
import FooterSection from "../components/FooterSection";
import CategoriesNav from "../components/CategoriesNav";
import CartSection from "../components/CartSection";      // For cart modal in Nav
import { CreditCard, Smartphone, Lock, Check, MapPin, User, Mail, Phone, ShoppingBag, ArrowLeft } from 'lucide-react';
 


  const Design1 = ({ 
  formData, 
  handleInputChange, 
  paymentMethod, 
  setPaymentMethod, 
  cartItems, 
  formatCurrency, 
  subtotal, 
  shipping, 
  total, 
  checkoutText, 
  customStyles,
  Addresses,
  couriers,
  title,
  shippingTitle,
  paymentTitle,
  containerStyles,
  onSaveOrder,
  featuredBg,
  navigate,
}) => (
     <div className={`flex-grow ${containerStyles.background || 'bg-white'}`} style={containerStyles}>
    <div className="max-w-7xl mt-[-20px] md:mt-[-50px] mx-auto px-4 sm:px-6 py-8 md:py-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-12">
        {/* Left: Forms */}
        <div className="space-y-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">{title}</h1>

          <h2 className="text-2xl font-bold text-gray-900 mb-6">{shippingTitle}</h2>
          <form className="space-y-6">
            {/* all your inputs here – exactly as before */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border …"
                  placeholder="John Kenya"
                />
              </div>
               <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                    placeholder="Doe"
                  />
                </div>
            </div>

             <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                  placeholder="0712345678"
                />
              </div>

                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Street Address</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                  placeholder="123 Main Street"
                />
              </div>

            {/* delivery_mode & courier selects */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Select Delivery Mode</label>
                <select
                  name="delivery_mode"
                  value={formData.delivery_mode}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border …"
                >
                  <option value="">Select</option>
                  {Addresses?.map((s) => (
                    <option key={s.id} value={s.id}>{s.address}</option>
                  ))}
                </select>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Select Transport Means</label>
                <select
                  name="courier"
                  value={formData.courier}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border …"
                >
                  <option value="">Select</option>
                  {couriers
                    ?.filter((s) => s.address_id === formData.delivery_mode)
                    .map((s) => (
                      <option key={s.id} value={s.id}>{s.name}</option>
                    ))}
                </select>
              </div>
            </div>
             <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Additional Delivery Instructions</label>
                <textarea
                  type="text"
                  name="instructions"
                  value={formData.instructions}
                  onChange={handleInputChange}
                  
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                ></textarea>
              </div>
          </form>



     {/*    {paymentMethod === 'mpesa' && (
              <div className="bg-green-50 border border-green-200 rounded-xl p-6">
                <label className="block text-sm font-medium text-green-900 mb-2">M-Pesa Phone Number</label>
                <input
                  type="tel"
                  name="mpesaPhone"
                  value={formData.mpesaPhone}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent bg-white"
                  placeholder="254712345678"
                />
                <p className="text-sm text-green-700 mt-2">
                  You'll receive an STK push on your phone to complete payment
                </p>
              </div>
            )}

         */}

            {paymentMethod === 'card' && (
              <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-blue-900 mb-2">Card Number</label>
                    <input
                      type="text"
                      name="cardNumber"
                      value={formData.cardNumber}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent bg-white"
                      placeholder="1234 5678 9012 3456"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-blue-900 mb-2">Expiry Date</label>
                      <input
                        type="text"
                        name="cardExpiry"
                        value={formData.cardExpiry}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent bg-white"
                        placeholder="MM/YY"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-blue-900 mb-2">CVV</label>
                      <input
                        type="text"
                        name="cardCvv"
                        value={formData.cardCvv}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent bg-white"
                        placeholder="123"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>

         <div className="lg:sticky lg:top-8 lg:self-start">
            <div className="bg-white rounded-xl p-8 shadow">
              <h2 className="text-2xl font-bold mb-8">Order Summary</h2>
              <div className="space-y-6">
                {cartItems.map((item) => (
                  <div key={item.id} onClick={(e)=>navigate('/products/'+item.product_id)} className="flex gap-6 pb-6 border-b last:border-0 last:pb-0 cursor-pointer" title="Click to view product">
                     <div className="w-[100px] h-[80px] rounded-xl overflow-hidden bg-gray-100">
  <img
    src={item.image || 'https://placehold.co/96x96?text=No+Image'}
    alt={item.name}
    className="w-full h-full"
    loading="lazy"
    decoding="async"
  />
</div>
                    <div className="flex-1">
                      <h3 className="font-medium text-lg">{item.name}</h3>
                      <p className="text-sm text-gray-600 mt-1">Qty: {item.quantity}</p>
                      <p className="font-semibold mt-2">{formatCurrency((item.price * item.quantity))}  {item.hasVariants &&(
              <span className="bg-green-600 text-white ml-4 rounded p-1">{item.countVariants} variant(s)</span>
              )}</p>
                    </div>
                  </div>
                ))}
                <div className="pt-6 space-y-3">
                  <div className="flex justify-between text-gray-700">
                    <span>Subtotal</span>
                    <span>{formatCurrency(subtotal)}</span>
                  </div>
                  <div className="flex justify-between text-gray-700">
                    <span>Shipping</span>
                    <span>{formatCurrency(shipping)}</span>
                  </div>
              {/*    <div className="flex justify-between text-gray-700">
                    <span>Tax (16%)</span>
                    <span>{formatCurrency(tax)}</span>
                  </div>*/}
                  <div className="flex justify-between font-bold text-xl pt-4 border-t">
                    <span>Total</span>
                    <span>{formatCurrency(total)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <button onClick={()=>onSaveOrder()} className={`w-full mt-12 py-5 rounded-xl font-bold text-lg  ${customStyles.buttonText}`} style={{backgroundColor:featuredBg}}>{checkoutText} - {formatCurrency(total)}</button>
   <br/><br/><br/>
    </div>
  </div>
);


  // Design 2: Multi-Step Wizard (Guided Flow)
  const Design2 = () => (
   <div></div>
  );

  // Design 3: Compact Mobile-First
  const Design3 = () => (
   <div></div>
  );

const CACHE_KEY = 'checkout_page_cachedf';
const CACHE_TTL = 24*60*60 * 1000; // 1 minute

const CheckoutPage = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
const userInfo = localStorage.getItem('userInfor');
//console.log(userInfo);
   if(!userInfo){
   // console.log('Not Logged In');
  navigate('/Authentication');
}

  const [step, setStep] = useState(1);
  const[couriers,setCouriers]=useState([]);
  const[Addresses,setAddresses]=useState([]);
  const [paymentMethod, setPaymentMethod] = useState('mpesa');
 const [user, setUser] = useState(null);
  const [cartuser, setCartUser] = useState(null);
 const token = localStorage.getItem('token');
 let featuredBg = localStorage.getItem('featuredBg') || config.BASE_COLOR;
  const activeBg = localStorage.getItem('activeBg') || config.BASE_COLOR;
if(featuredBg=='bg-gray-400'){
  featuredBg=config.BASE_COLOR;
}
  // Layout configs – start null, filled from cache instantly
  const [flashConfig, setFlashConfig] = useState(null);
  const [navConfig, setNavConfig] = useState(null);
  const [cartConfig, setCartConfig] = useState(null);
  const [checkoutConfig, setCheckoutConfig] = useState(null);
  const [footerConfig, setFooterConfig] = useState(null);
  const [cartItems, setCartItems] = useState([]); 
  const[delivery_fee,setDeliveryFee]=useState(0);
  const [catNavConfig, setcatNavConfig] = useState(null);


   const handleSaveOrder = async () => {
    try {
  

  //delivery_fee = selectedAddress ? Number(selectedAddress.amount || 0) : 0;

  // You can also validate here
  if (!formData.delivery_mode) {
    alert("Please select a delivery mode");
    return;
  }

   if (!formData.courier) {
    alert("Please select tranport means");
    return;
  }

   if (!formData.address?.trim()) {
    alert("Please add an address");
    return;
  }
      //setSaving(true);
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      const endpoint ='/api/saveOrder';

        

      const response = await axios.post(
        config.API_URL + endpoint,
        {formData,total_amount:total,delivery_fee:delivery_fee,token:token},
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (response.data.success === 1) {
        navigate('/success');
       // navigate('/Orders/'+response.data.order_number);
      
      } else {
        alert("Save failed.");
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save.");
    } finally {
      //setSaving(false);
    }
  };

  const defaultConfig = {
    activeDesign: 'side-by-side', // 'side-by-side', 'wizard', 'compact'
    title: 'Checkout',
    shippingTitle: 'Shipping Information',
    paymentTitle: 'Payment Method',
    reviewTitle: 'Review Your Order',
    emptyCartMessage: 'Your cart is empty',
    continueShoppingText: 'Continue Shopping',
    checkoutText: 'Complete Order',
    customStyles: {
      background: 'bg-gray-50',
      textColor: 'text-gray-900',
      buttonBg: featuredBg,
      buttonText: 'text-white',
      accentColor: 'text-green-600',
    },
  };

  const finalConfig = { ...defaultConfig, ...checkoutConfig };
  const {
    activeDesign,
    title,
    shippingTitle,
    paymentTitle,
    reviewTitle,
    emptyCartMessage,
    continueShoppingText,
    checkoutText,
    customStyles,
  } = finalConfig;

  // ────────────────────────────────────────────────
  // Cache Helpers
  // ────────────────────────────────────────────────
  const getCached = () => {
    const item = localStorage.getItem(CACHE_KEY);
    if (!item) return null;
    try {
      const { data, timestamp } = JSON.parse(item);
      if (Date.now() - timestamp < CACHE_TTL) return data;
      localStorage.removeItem(CACHE_KEY);
      return null;
    } catch {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }
  };

  const setCached = (data) => {
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      data,
      timestamp: Date.now(),
    }));
  };

  // ────────────────────────────────────────────────
  // Load Layout → Cache FIRST, then background API refresh
  // ────────────────────────────────────────────────
 
  // Fetch full cart items
  const pullCartItems = useCallback(async () => {
    

    try {
      const response = await axios.get(`${config.API_URL}/api/collectcart/`+token, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
        withCredentials: true,
      });
      setCartItems(response.data.cartItems || []);
       setCartUser(response.data.cartUser);
    } catch (err) {
      console.error('Failed to load cart:', err);
    }
  }, []);

  // Load cart items on mount
  useEffect(() => {
    pullCartItems();
  }, [pullCartItems]);

  const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

  // Safe config handling
  const actualCheckoutConfig = 
    checkoutConfig?.checkoutSettings && typeof checkoutConfig.checkoutSettings === 'object' && !Array.isArray(checkoutConfig.checkoutSettings)
      ? checkoutConfig.checkoutSettings
      : (typeof checkoutConfig === 'object' && !Array.isArray(checkoutConfig) ? checkoutConfig : {});

  const checkoutDefault = {
    activeDesign: 'side-by-side',
    devMode: false,
    customStyles: {},
  };

  const finalCheckoutConfig = { ...checkoutDefault, ...actualCheckoutConfig };
  const { activeDesign: checkoutDesign, devMode: checkoutDevMode, customStyles: checkoutStyles } = finalCheckoutConfig;

  const containerStyles = {
    background: checkoutDevMode && checkoutStyles.background ? checkoutStyles.background : undefined,
    color: checkoutDevMode && checkoutStyles.textColor ? checkoutStyles.textColor : undefined,
  };

    const fetchUser = async () => {
   
    try {
      const res = await axios.get(`${config.API_URL}/api/pullusers/${token}`);
      if (res.data.status === 0) {
        // handle deactivated account if needed
      } else {
        if(res.data.user?.is_confirmed!=1){
         // navigate('/Authentication');
        }
        setUser(res.data.user);
        setAddresses(res.data.Addresses);
        setCouriers(res.data.couriers);
        setCartUser(res.data.cartUser);
        localStorage.setItem('userInfor', JSON.stringify(res.data.user));
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      localStorage.removeItem('userInfor');
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  // ── Mock Cart & Form Data ──────────────────────────────────────────────────
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    zipCode: '',
    country: 'Kenya',
    mpesaPhone: '',
    cardNumber: '',
    delivery_mode:'',
    courier:'',
    cardName: '',
    instructions:'',
    cardExpiry: '',
    cardCvv: '',
  });

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);
  const shipping = delivery_fee;
  const tax = subtotal * 0.16;
  const total = subtotal+shipping;

const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;

    setFormData(prev => {
        // We calculate using the NEW value that is about to be set
        if (name === "delivery_mode") {
            const selectedAddress = Addresses.find(
                addr => String(addr.id) === String(value)   // ← use value here!
            );

            const newFee = selectedAddress ? Number(selectedAddress.amount || 0) : 0;
            setDeliveryFee(newFee);

            // Optional: toast inside the updater (safer timing)
            if (newFee > 0) {
                toast.success(`Delivery fee: KSh ${newFee}`);
            } else if (value) {
                toast.error("No fee found for this delivery mode");
            }
        }

        // Return the new formData state
        return {
            ...prev,
            [name]: value
        };
    });
}, [Addresses]);

  

  

   useEffect(() => {
    if (!cartuser && !user) return;

    setFormData(prev => ({
      ...prev,
      firstName:  cartuser.firstname || user.name || prev.firstName,
      lastName:   cartuser.lastname   || prev.lastName,
      // email:   cart   user.email      || prev.email,     // usually don't allow change
      phone:      user.phone    || user.contact || prev.phone,
      address:    cartuser.destination|| prev.address,
      // You can add more defaults here if needed
    }));
  }, [user]);




const renderCheckoutDesign = () => {
  switch (checkoutDesign) {
    case 'side-by-side': 
      return (
        <Design1 
          formData={formData}
          handleInputChange={handleInputChange}
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          cartItems={cartItems}
          formatCurrency={formatCurrency}
          subtotal={subtotal}
          shipping={shipping}
          total={total}
          checkoutText={checkoutText}
          customStyles={customStyles}
          Addresses={Addresses}
          couriers={couriers}
          title={title}
          shippingTitle={shippingTitle}
          paymentTitle={paymentTitle}
          containerStyles={containerStyles}
           onSaveOrder={handleSaveOrder}
           featuredBg={featuredBg}
           navigate={navigate}
        />
      );
    case 'wizard':    return <Design2 />;
    case 'compact':   return <Design3 />;
    default:          return <Design1 /* props */ />;
  }
};

 

  return (
    <div className="flex flex-col min-h-screen relative">
      {/* Flash Bar */}
      <ShareableNav/>
      {/* Main Checkout Content */}
      {loading && (
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-xl text-gray-600">Loading....</p>
      </div>
        )}

       {!loading && (
      <main className="flex-grow " style={containerStyles}>
      <br/> <br/><br/> <br/>
        {renderCheckoutDesign()}
      </main>
       )}

      {/* Footer */}
      {footerConfig && <FooterSection config={footerConfig} />}
    </div>
  );
};

export default CheckoutPage;